import React, { useEffect, useRef, useState } from 'react';
import { Card, Row, Col, ListGroup } from "react-bootstrap";
import { Input, InputGroup, Form, Table, Button, Modal } from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import sosLookupService from '../../../services/Internal/sosLookup.service';
import LoadingSpinner from '../GenericComponents/LoadingSpinner';
import { useReactToPrint } from 'react-to-print';
import BlockUi from '@availity/block-ui';
import Swal from 'sweetalert2';
import { FaPrint } from 'react-icons/fa';
const { Column, HeaderCell, Cell } = Table;
const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
function SOSLookup(props) {
    const [model, setModel] = useState()
    const [results, setResults] = useState();
    const [isDataLoading, setIsDataLoading] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState();
    const handleOpen = () => {
        setModalOpen(true);
    };
    const handleClose = () => setModalOpen(false);

    const lookup = () => {
        setResults(null)
        setIsDataLoading(true);
        sosLookupService.getSosLookupData(model).then(data => {
            console.log(data.data)
            if (data.data.Status == "AccessDenied" && data.data.ResponseCode == "MaxRequestLimitReached") {
                Swal.fire("Warning!", "You have reached the maximum amount of data calls to the Secretary of State. Please wait up to 1 minute before trying to search again.", 'info');
            }
            else {
                if (data.data?.EntitySearchResults) {
                    var filteredData = data.data?.EntitySearchResults.filter((val) => val && val["EntityTypeId"] != "8" && val["EntityTypeId"] != "16")
                    setResults(filteredData);
                }
            }
            setIsDataLoading(false);
        });
    }
    const onEntityClick = (data) => {
        setModalData(data);
        handleOpen();
    }

    useEffect(() => {
        setModel(props.entityName)
    }, [])

    return (
        <Card>
            <Card.Header><h6>Secretary of State Lookup</h6></Card.Header>
            <Card.Body >
                <SosEntityModal modalData={modalData} modalOpen={modalOpen} handleClose={handleClose} />
                <h6>Use the input below to search the Secretary of State's firm lookup. </h6>
                <Form.Group>
                    <InputGroup>
                        <Input
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    lookup();
                                }
                            }}
                            value={model} onChange={setModel} />
                        <InputGroup.Button onClick={() => lookup()} >
                            <SearchIcon />
                        </InputGroup.Button>
                    </InputGroup>
                </Form.Group>
                <Row>
                    <Col>
                        {results ? <>
                            <center><b>Active</b> records are shown in <b>Bold.</b></center>
                            <p>Total results: {results.length}</p>
                            <Table
                                autoHeight={true}
                                maxHeight={500}
                                showHeader={true}
                                data={results}
                                bordered={true}
                                wordWrap={true}
                                onRowClick={onEntityClick}
                                rowClassName={(rowData, i) => {
                                    var className = rowData?.EntityStatus.startsWith("A") ? "fw-bold sosRow" : "sosRow"
                                    className += i % 2 == 0 ? " row-even" : " row-odd"
                                    return className;
                                }}
                            >
                                <Column verticalAlign={'middle'} flexGrow={4}>
                                    <CompactHeaderCell>
                                        Name
                                    </CompactHeaderCell>
                                    <CompactCell dataKey="Name"></CompactCell>
                                </Column>
                                <Column verticalAlign={'middle'} flexGrow={1.25}>
                                    <CompactHeaderCell>
                                        Type
                                    </CompactHeaderCell>
                                    <CompactCell dataKey="TypeName"></CompactCell>
                                </Column>
                                <Column verticalAlign={'middle'} flexGrow={1}>
                                    <CompactHeaderCell>
                                        City
                                    </CompactHeaderCell>
                                    <CompactCell dataKey="City"></CompactCell>
                                </Column>

                            </Table>
                        </> : isDataLoading ? <LoadingSpinner /> : <></>

                        }
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}
function SosEntityModal(props) {
    const [entityData, setEntityData] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [printLoading, setPrintLoading] = useState(false);
    const componentRef = useRef(null);
    const promiseResolveRef = useRef(null);
    const handlePrint = useReactToPrint({
        documentTitle: props.modalData?.Name,
        contentRef: componentRef,
        onBeforePrint: () => {
            return new Promise((resolve) => {
                promiseResolveRef.current = resolve;
                setPrintLoading(true);
            });
        },
        onAfterPrint: () => {
            promiseResolveRef.current = null;
            setPrintLoading(false);
        }
    });
    useEffect(() => {
        if (printLoading && promiseResolveRef.current) {
            // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
            promiseResolveRef.current();
        }
    }, [printLoading]);


    useEffect(() => {
        if (props.modalOpen) {
            setIsLoading(true)
            sosLookupService.getSosEntityData(props.modalData?.EntityNumber, props.modalData?.EntityTypeId).then(data => {
                setEntityData(null);
                if (data.data.Status == "AccessDenied" && data.data.ResponseCode == "MaxRequestLimitReached") {
                    Swal.fire("Warning!", "You have reached the maximum amount of data calls to the Secretary of State. Please wait up to 1 minute before trying to search again.", 'info').then(() => { props.handleClose() });
                }
                else {
                    setEntityData(data.data);
                }
                setIsLoading(false)
            });
        }
    }, [props.modalData])

    const getPagePrintStyle = () => {
        return '@media print {.scroll-container {width:100% !important;height:100% !important;overflow: visible;} body{zoom:75%; display:block;}}';
    };
    return (
        <BlockUi blocking={printLoading}>
            <style>{getPagePrintStyle()}</style>
            <Modal size={'full'} open={props.modalOpen} onClose={props.handleClose}>
                <Modal.Body ref={componentRef} className="px-5">
                    {isLoading ? <LoadingSpinner /> : <>

                        {entityData?.CharterDetails &&
                            <>
                                <Card>
                                    <Card.Header>
                                        <Row>
                                            <Col sm={8}>
                                                <h4>{entityData.CharterDetails.CharterName}<br /> [{entityData.CharterDetails.BusinessType}]</h4>
                                            </Col>
                                            <Col className="justify-content-end d-flex align-items-center">
                                                <h4>
                                                    <div className={entityData.CharterDetails.CharterStatusDescription == "Active" ? "text-success" : "text-danger"}>{entityData.CharterDetails.CharterStatusDescription}</div>
                                                    <div className={entityData.CharterDetails.AnnualReportStatus?.startsWith("Not") ? "text-danger" : "text-success"}>{entityData.CharterDetails.AnnualReportStatus}</div>
                                                </h4>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row className="mb-2">
                                            <Col>
                                                <h6>Charter Number</h6>
                                                {entityData.EntityNumber}
                                            </Col>
                                            <Col>
                                                <h6>Annual Report Status</h6>
                                                {entityData.CharterDetails.AnnualReportStatus}
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col>
                                                <h6>Registration Date</h6>
                                                {new Date(entityData.CharterDetails.RegistrationDate).toLocaleDateString('en-US', { timeZone: 'UTC' })}
                                            </Col>
                                            <Col>
                                                <h6>Qualified</h6>
                                                {new Date(entityData.CharterDetails.FileDate).toLocaleDateString('en-US', { timeZone: 'UTC' })}
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col>
                                                <h6>City</h6>
                                                {entityData.CharterDetails.City}
                                            </Col>

                                            <Col>
                                                <h6>Last Report Filed</h6>
                                                {new Date(entityData.CharterDetails.LastReportFiled).toLocaleDateString('en-US', { timeZone: 'UTC' })}
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <br />
                                <Card>
                                    <Card.Title className="ps-2 pt-2"><b>Previous Names</b></Card.Title>
                                    <ListGroup variant="flush">
                                        {entityData.CharterDetails?.PreviousNames?.length > 0 ?
                                            <>{entityData.CharterDetails.PreviousNames.map((val) => { return (<ListGroup.Item>{`${val.Name} (Changed: ${new Date(val.ChangeDate).toLocaleDateString('en-US', { timeZone: 'UTC' })})`}</ListGroup.Item>) })}</>
                                            : <ListGroup.Item>No Previous Names Found</ListGroup.Item>
                                        }
                                    </ListGroup>
                                </Card>
                                <br />
                                <Row><h4>Addresses</h4></Row>
                                <Row>
                                    {entityData.CharterDetails.Addresses.map((val) => {
                                        return (<Col sm={4}>
                                            <Card className="p-2 mb-2">
                                                <Card.Title>
                                                    <b>{val.AddressType}</b>
                                                </Card.Title>
                                                <Card.Text>
                                                    {val.Address1}<br />
                                                    {val.City}, {val.State} {val.ZipCode}
                                                </Card.Text>
                                            </Card>
                                        </Col>)
                                    })}
                                </Row>
                                <br />
                                <Row><h4>Registered Agent(s)</h4></Row>
                                <Row>
                                    {entityData.CharterDetails?.Agents?.length > 0 ?
                                        <>{
                                            entityData.CharterDetails.Agents.map((val) => {
                                                return (<Col sm={4}>
                                                    <Card className="p-2 mb-2">
                                                        <Card.Title>
                                                            <b>{val.FirstName}</b> ({new Date(val.AppointmentDate).toLocaleDateString('en-US', { timeZone: 'UTC' })})
                                                        </Card.Title>
                                                        <Card.Text>
                                                            {val.Address1}<br />
                                                            {val.City}, {val.State} {val.ZipCode}
                                                        </Card.Text>
                                                    </Card>
                                                </Col>)
                                            })
                                        }
                                        </> : <h3>No Agents Found</h3>
                                    }
                                </Row>
                                <br />
                                <Row><h4>Officer(s)</h4></Row>
                                <Row>
                                    {entityData.CharterDetails?.Officers?.length > 0 ?
                                        <>
                                            {entityData.CharterDetails.Officers.map((val) => {
                                                return (<Col sm={4}>
                                                    <Card className="p-2 mb-2">
                                                        <Card.Title>
                                                            <b>{val.FirstName}</b> [{val.Titles.join(', ')}]
                                                        </Card.Title>
                                                        <Card.Text>
                                                            {val.Address1}<br />
                                                            {val.City}, {val.State} {val.ZipCode}
                                                        </Card.Text>
                                                    </Card>
                                                </Col>)
                                            })
                                            }
                                        </> : <h3>No Officers Found</h3>
                                    }
                                </Row>
                                <br />
                                <Row><h4>Amendments on File ({entityData.CharterDetails.Amendments?.length})</h4></Row>
                                <table style={{ width: '100%', borderCollapse: "collapse" }}>
                                    <tr>
                                        <th style={{ border: "2px solid black", padding: "5px" }}>Description</th>
                                        <th style={{ border: "2px solid black", padding: "5px" }}>Date</th>
                                    </tr>
                                    {entityData.CharterDetails.Amendments.map((val, i) => {
                                        return (<tr style={{ backgroundColor: i % 2 == 0 ? "#e3e3e3e3" : "" }} >
                                            <td style={{ border: "2px solid black", padding: "5px" }}>{val.Description}</td>
                                            <td style={{ border: "2px solid black", padding: "5px" }}>{new Date(val.DateFiled).toLocaleDateString('en-US', { timeZone: 'UTC' })}</td>
                                        </tr>)

                                    })}
                                    <tr>
                                    </tr>
                                </table>
                            </>
                        }
                    </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handlePrint}><FaPrint /> Print</Button>
                    <Button onClick={props.handleClose} appearance="primary">
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </BlockUi>
    )
}


export default SOSLookup;